export default __webpack_public_path__ + "static/media/lungTest.6038361f.svg";